module.exports = __webpack_public_path__ + "static/media/jt7.68565e2c.png";